import reno from "../assets/products-images/reno.jpeg";
import regalo from "../assets/products-images/regalo.jpeg";
import copoNieveMini from "../assets/products-images/copo-de-nieve-mini.jpeg";
import muñecoNieve from "../assets/products-images/muñeco-de-nieve.jpeg";
import botaNavidad from "../assets/products-images/bota-de-navidad.jpeg";
import arbolPino from "../assets/products-images/arbol-pino.jpeg";
import papaNoel from "../assets/products-images/papa-noel.jpeg";
import canastaVela from "../assets/products-images/canasta-de-vela.jpeg";
import cuboEsferas from "../assets/products-images/cubo-de-esferas.jpeg";
import arbolEspiral from "../assets/products-images/arbol-espiral.jpeg";
import piramide from "../assets/products-images/piramide.jpeg";
import luxe from "../assets/products-images/luxe.jpeg";
import arcoiris from "../assets/products-images/arcoiris.jpeg";
import velaCandelabro from "../assets/products-images/vela-candelabro.jpeg";
import velaMujer from "../assets/products-images/vela-mujer-flores-pelo.jpeg";
import copoNieve from "../assets/products-images/copo-de-nieve.jpeg";
import arbolMini from "../assets/products-images/arbol-mini.jpeg";
import arbolCapas from "../assets/products-images/arbol-capas.jpeg";
import packsVelas from "../assets/products-images/packs-velas.jpeg";
import luxePequeña from "../assets/products-images/luxe-pequeña.jpeg";
import MuchoLove from "../assets/products-images/mucho-love.jpeg";
import ArcoirisM from "../assets/products-images/arcoíris-m.jpeg";
import OsitoTito from "../assets/products-images/osito-tito.jpeg";
import Morita from "../assets/products-images/morita.jpeg";
import Margaritas from "../assets/products-images/margaritas.jpg";
import MujerOjosVendados from "../assets/products-images/mujer-ojos-vendados.jpeg";
import Rosa from "../assets/products-images/rosa.jpg";
import LuxeS from "../assets/products-images/luxe-s.jpeg";
import burbujas from "../assets/products-images/Burbujas.JPG";
import casaNavidadArbol from "../assets/products-images/casa-navidad-arbol.jpg";
import casaNavideñaBastones from "../assets/products-images/casa-navideña-bastones.jpg";
import bolasMerryXmas from "../assets/products-images/bolas-merry-Xmas.jpg";
import arbolLazo from "../assets/products-images/arbol-lazo.jpg";
import florLoto from "../assets/products-images/flor-de-loto.jpg";
import pensadores from "../assets/products-images/pensadores.jpg";
import corazon from "../assets/products-images/corazon.jpg";
import bolaCoposDeNieve from "../assets/products-images/bola-copos-de-nieve.JPG";
import petaloSilvestre from "../assets/products-images/petalo-silvestre.JPG";

const products = [
  {
    id: 1,
    name: "Luxe XS",
    dimensions: "5,5 cm x 6 cm",
    price: "3€",
    image: luxePequeña,
  },
  {
    id: 2,
    name: "Luxe S",
    dimensions: "9 cm x 8,5 cm",
    price: "8€",
    image: LuxeS,
  },
  {
    id: 3,
    name: "Luxe M",
    dimensions: "8,5 cm x 8 cm",
    price: "12,5€",
    image: luxe,
  },
  {
    id: 4,
    name: "Mucho love",
    dimensions: "6 cm x 6 cm",
    price: "8€",
    image: MuchoLove,
  },
  {
    id: 5,
    name: "Pirámide",
    dimensions: "12 cm x 8 cm",
    price: "7€",
    image: piramide,
  },
  {
    id: 6,
    name: "Osito Tito",
    dimensions: "8 cm x 6,5 cm",
    price: "7€",
    image: OsitoTito,
  },
  {
    id: 7,
    name: "Arcoíris S",
    dimensions: "11,5 cm x 6 cm",
    price: "6€",
    image: arcoiris,
  },
  {
    id: 8,
    name: "Arcoíris M",
    dimensions: "14 cm x 14 cm",
    price: "8€",
    image: ArcoirisM,
  },
  {
    id: 9,
    name: "Rosa",
    dimensions: "7 cm x 3 cm",
    price: "5€",
    image: Rosa,
  },
  {
    id: 10,
    name: "Árbol espiral",
    dimensions: "9,5 cm x 7 cm",
    price: "6€",
    image: arbolEspiral,
  },
  {
    id: 11,
    name: "Árbol capas",
    dimensions: "8,5 cm x 6 cm",
    price: "4€",
    image: arbolCapas,
  },
  {
    id: 12,
    name: "Candelabro",
    dimensions: "15 cm x 4,5 cm",
    price: "5€",
    image: velaCandelabro,
  },
  {
    id: 13,
    name: "Copo de nieve",
    dimensions: "6,5 cm x 2,5 cm",
    price: "4€",
    image: copoNieve,
  },
  {
    id: 14,
    name: "Morita",
    dimensions: "5,8 cm x 6,5 cm",
    price: "5€",
    image: Morita,
  },
  {
    id: 15,
    name: "Mujer flores en el pelo",
    dimensions: "9 cm x 7 cm",
    price: "5€",
    image: velaMujer,
  },
  {
    id: 16,
    name: "Mujer ojos vendados",
    dimensions: "9,1 cm x 7,1 cm",
    price: "5€",
    image: MujerOjosVendados,
  },
  {
    id: 17,
    name: "Árbol mini",
    dimensions: "5 cm x 6 cm",
    price: "2€",
    image: arbolMini,
  },
  {
    id: 18,
    name: "Cubo de esferas",
    dimensions: "4 cm x 4 cm",
    price: "3€",
    image: cuboEsferas,
  },
  {
    id: 19,
    name: "Reno",
    dimensions: "4cm x 3,5 cm",
    price: "3€",
    image: reno,
  },
  {
    id: 20,
    name: "Margarita",
    price: "2€",
    image: Margaritas,
  },
  {
    id: 21,
    name: "Regalo",
    dimensions: "5 cm x 5 cm",
    price: "3€",
    image: regalo,
  },
  {
    id: 22,
    name: "Copo de nieve mini",
    dimensions: "5,5 cm x 5 cm",
    price: "3€",
    image: copoNieveMini,
  },
  {
    id: 23,
    name: "Muñeco de nieve",
    dimensions: "5 cm x 6 cm",
    price: "3€",
    image: muñecoNieve,
  },
  {
    id: 24,
    name: "Bota Navidad",
    dimensions: "5,5 cm x 5,3 cm",
    price: "3€",
    image: botaNavidad,
  },
  {
    id: 25,
    name: "Pino",
    dimensions: "7 cm x 5,5 cm",
    price: "3€",
    image: arbolPino,
  },
  {
    id: 26,
    name: "Papá Noel",
    dimensions: "6 cm x 6 cm",
    price: "3€",
    image: papaNoel,
  },
  {
    id: 27,
    name: "Canasta de vela",
    dimensions: "6 cm x 3 cm",
    price: "3€",
    image: canastaVela,
  },
  {
    id: 28,
    name: "Packs de Velas",
    price: "20€",
    image: packsVelas,
  },
  {
    id: 29,
    name: "Burbujas",
    dimensions: "4,5 cm x 16,5 cm",
    price: "3€",
    image: burbujas,
  },
  {
    id: 30,
    name: "Casa navidad árbol",
    dimensions: "8 cm x 5,5 cm",
    price: "3€",
    image: casaNavidadArbol,
  },
  {
    id: 31,
    name: "Casa navideña bastones",
    dimensions: "8 cm x 5,5 cm",
    price: "3€",
    image: casaNavideñaBastones,
  },
  {
    id: 32,
    name: "Bolas merry Xmas",
    dimensions: "6,5 cm x 5,8 cm",
    price: "4€",
    image: bolasMerryXmas,
  },
  {
    id: 33,
    name: "Árbol lazo",
    dimensions: "7,1 cm x 11,8 cm",
    price: "6€",
    image: arbolLazo,
  },
  {
    id: 34,
    name: "Flor de loto",
    dimensions: "6 cm x 6 cm",
    price: "4€",
    image: florLoto,
  },
  {
    id: 35,
    name: "Pensadores Pack",
    price: "5€",
    image: pensadores,
  },
  {
    id: 36,
    name: "Corazón",
    price: "3€",
    image: corazon,
  },
  {
    id: 37,
    name: "Bola copos de nieve",
    dimensions: "6,5 cm x 5,8 cm",
    price: "4€",
    image: bolaCoposDeNieve,
  },
  {
    id: 38,
    name: "Pétalo Silvestre",
    dimensions: " 3 cm x 5 cm x 8 cm",
    price: "2€",
    image: petaloSilvestre,
  },
];

export default products;
